export default "__VITE_ASSET__Ct6a_tnP__"